import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteLayout } from './SiteChrome.js';

export function PrivacyPage() {
  useEffect(() => {
    document.title = 'Our Commitment to Confidentiality | Voice to Value';
  }, []);

  return (
    <SiteLayout>
      <article className="v2v-doc">
        <div className="shell">
          <div className="doc-head">
            <p className="eyebrow">Privacy &amp; confidentiality</p>
            <h1>Our Commitment to Confidentiality</h1>
            <p className="doc-lead">
              At Voice to Value, we understand that honest feedback can only be achieved when
              employees feel safe to share their views. That&rsquo;s why confidentiality and data
              protection are at the heart of everything we do.
            </p>
          </div>

          <div className="doc-body">
            <p>
              Every survey is set up with the level of anonymity you choose, from fully anonymous,
              where responses are never attributed to individuals, through to named responses where
              employees are happy to be identified. Whichever level is chosen, participants are told
              clearly how their feedback will be handled before they take part.
            </p>
            <p>
              Where a survey is anonymous, data is grouped and reported at a level that prevents
              individual respondents from being identified, particularly within smaller teams or
              departments. Where response numbers are too low to guarantee confidentiality, results
              may be combined with larger groups or excluded from detailed reporting.
            </p>

            <p className="pull">
              Honest feedback can only be achieved when employees feel safe to share their views.
            </p>

            <p>
              We are committed to handling all survey data securely and responsibly. Information is
              used solely for the purpose of understanding employee engagement, workplace culture,
              and organisational effectiveness. Survey responses are never shared with third parties
              for marketing or commercial purposes.
            </p>
            <p>
              Our goal is simple: to create a trusted environment where employees can speak openly
              and organisations can gain meaningful insights that lead to positive change.
            </p>

            <Link to="/" className="back">
              ← Back to Voice to Value
            </Link>
          </div>
        </div>
      </article>
    </SiteLayout>
  );
}
